import React from 'react';

type DataTableHeadType = {
  children: React.ReactNode;
};

const DataTableHead = ({ children }: DataTableHeadType): JSX.Element => {
  return (
    <div className='flex w-full text-left bg-gray-lightest border-b border-gray-light py-5 px-8'>
      {children}
    </div>
  );
};

export default DataTableHead;
